import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_USER } from "@/constants/resultsLimits";
import createUserGroupFilter from "@/utilities/createUserGroupFilter";

/**
 * Returns all active users (max. {@link RESULTS_LIMIT_USER}: Geotab rejects a larger User
 * request). `isTruncated` is true when a full page came back, so more users may exist.
 */
export function useAllUsers() {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();

  const query = useQuery({
    queryKey: ["allUsers", activeSessionId, groups, groupFilterCondition],
    queryFn: ({ signal }) => {
      const now_utc = new Date(new Date().toUTCString());
      const filter = createUserGroupFilter(groups, groupFilterCondition, {
        fromDate: now_utc,
        toDate: now_utc,
      });

      return geotabClient.get("User", filter, RESULTS_LIMIT_USER, signal);
    },
  });

  return Object.assign(query, {
    isTruncated: (query.data?.length ?? 0) >= RESULTS_LIMIT_USER,
  });
}
